<ng-container *ngIf="utility.loaded | async">
  <div class="page-body">
    <div class="log-in-left">
      <a [href]="webURL" target="_blank"><img class="logo" [src]='logoURL' alt="VComply"
          onerror="this.src='../assets/images/logo.svg';" /></a>
      <div class="log-in-mid">
        <app-infographic-slider></app-infographic-slider>
      </div>
      <div class="log-in-footer">
        We use cookies to track usage and preferences to improve our services. For more details read our <a
          rel="noreferrer" href="https://www.v-comply.com/privacy/" target="_blank">privacy policy</a><br />
        Copyright © {{year}} VComply Technologies, Inc. All rights reserved.
      </div>
    </div>
    <div class="log-in-right">
      <app-routing-wrapper>
        <!-- <app-signin-up-toggle *ngIf="signInUpToggle"></app-signin-up-toggle> -->
        <app-form-loader *ngIf="loadingRouteConfig"></app-form-loader>
        <ng-container *ngIf="!loadingRouteConfig">
          <router-outlet></router-outlet>
        </ng-container>
      </app-routing-wrapper>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="!(utility.loaded | async)">
  <app-v-loader></app-v-loader>
</ng-container>